import { CLIENT_CERTIFICATES_TABLE } from './client_certificates';

export const Clients = {
  en: {
    Name: 'Name',
    Birthday: 'Birthday',
    Phone: 'Phone',
    Email: 'Email',
    'Important Notes': 'Important Notes',
    'Create Client': 'Create Client',
    Actions: 'Actions',
    'Insurance signed': 'Insurance signed',
    Created: 'Created',
    'Last Visit': 'Last Visit',
    Search: 'Search',
    From: 'From',
    Till: 'Till (Not Including)',
    'Black list': 'Black list',
    'Only black-listed': 'Only black-listed',
  },
  uk: {
    Name: "Ім'я",
    Birthday: 'Д.Н.',
    Phone: 'Телефон',
    Email: 'Пошта',
    'Important Notes': 'Нотатки',
    'Create Client': 'Створити Клієнта',
    Actions: 'Дії',
    'Insurance signed': 'Страховка підписана',
    Created: 'Створений',
    'Last Visit': 'Ост. візит',
    Search: 'Пошук',
    From: 'Від',
    Till: 'До (Не Включно)',
    'Black list': 'Чорний список',
    'Only black-listed': 'Лише з чорного списку',
  },
};

export const ClientForm = {
  en: {
    ...Clients.en,
    'New Client': 'New Client',
    'Edit Client': 'Edit Client',
    'Update Client': 'Update Client',
    'Client Photo': 'Client Photo',
    'Client Signature': 'Client Signature',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    'Middle Name': 'Middle Name',
    Comments: 'Comments',
    'Created By': 'Created By',
    'Choose Client Photo File': 'Choose Client Photo File',
    'Choose Client Signature File': 'Choose Client Signature File',
    'print eng form': 'Print ENG Form',
    'print uk form': 'Print UK Form',
    'Black list note': 'Black list note',
    'Add to black list': 'Add to black list',
    'Remove from black list': 'Remove from black list',
    'Remove the client from the black list?':
      'Remove the client from the black list?',
  },
  uk: {
    ...Clients.uk,
    'New Client': 'Створення Клієнта',
    'Edit Client': 'Редагування Клієнта',
    'Update Client': 'Оновити Клієнта',
    'Client Photo': 'Фото Клієнта',
    'Client Signature': 'Підпис Клієнта',
    'First Name': "Ім'я",
    'Last Name': 'Прізвище',
    'Middle Name': 'По батькові',
    Comments: 'Коментарі',
    'Created By': 'Створено',
    'Choose Client Photo File': 'Виберіть Файл з Фото Клієнта',
    'Choose Client Signature File': 'Виберіть Файл з Фото Підпису Клієнта',
    'print eng form': 'Друк анкети ENG',
    'print uk form': 'Друк анкети УКР',
    'Black list': 'Чорний список',
    'Black list note': 'Примітка до чорного списку',
    'Add to black list': 'Додати до чорного списку',
    'Remove from black list': 'Видалити з чорного списку',
    'Remove the client from the black list?':
      'Видалити клієнта з чорного списку?',
  },
};

export const ClientShow = {
  en: {
    ...Clients.en,
    ...CLIENT_CERTIFICATES_TABLE.en,
    'Added to black list': 'Added to black list',
    'Personal Info': 'Personal Info',
    'Lead climbing': 'Lead climbing',
    'Card Number': 'Card Number',
    'Card Numbers': 'Card Numbers',
    'Add Card Number': 'Add Card Number',
    Comments: 'Comments',
    'Buy New Service': 'Buy New Service',
    Sale: 'Sale',
    'Buy Service': 'Buy Service',
    ServicesCount: '{{count}} Services',
    'Use Certificate': 'Use Certificate',
    'Certificate Code': 'Certificate Code',
    'Certificate Already Used': 'Certificate Already Used',
    Cart: 'Cart',
    'Current Purchased Services': 'Current Purchased Services',
    'Current Active Purchased Services': 'Current Active Purchased Services',
    'Previously Purchased Services Without Discounts':
      'Previously Purchased Services Without Discounts',
    'Current Active Discounts': 'Current Active Discounts',
    'Previously Purchased Discounts': 'Previously Purchased Discounts',
    'Discount Type': 'Discount Type',
    'Purchased Service Id': 'PS Id',
    Service: 'Service',
    'Service Type': 'S Type',
    'Buy Time': 'Buy Time',
    Expiration: 'Expiration',
    Balance: 'Balance',
    'Previously Purchased Services': 'Previously Purchased Services',
    'Service Usage History': 'Service Usage History',
    'Payment Types': 'Payment Types',
    Card: 'Card',
    Subscription: 'Subscription',
    UseServiceConfirmText:
      'Are you, sure, that you want use <b>{{name}}</b> \
      service for <b>{{client_name}}</b> ?',
    UseServiceWithTrainerConfirmText:
      'Are you, sure, that you want use \
      <b>{{name}}</b> service for <b>{{client_name}}</b> with trainer \
      <b>{{trainer_name}}</b>?',
    CancelOrderConfirmText:
      'Are you sure that you want to cancel <b>{{order_id}}</b> \
      order for <b>{{client_name}}</b>?',
    CancelOnlineOrderConfirmText:
      'Are you sure that you want to cancel <b>{{order_id}}</b> \
      online order for <b>{{client_name}}</b>?',
    CancelOrderToDepositConfirmText:
      'Are you sure that you want to cancel <b>{{order_id}}</b> \
      order for <b>{{client_name}}</b> and return the money to the deposit?',
    CancelServiceUsageConfirmText:
      'Are you, sure, that you want cancel <b>{{name}}</b> \
      service usage for <b>{{client_name}}</b>?',
    UseServiceText: 'Use {{service_id}}',
    UseServiceWithTrainerText: 'Use {{service_id}} with trainer',
    'Add trainers to system to use this service':
      'Add trainers to system to use this service',
    'Client Signature': 'Client Signature',
    'Client photo': 'Client photo',
    "Cart can't be empty": "Cart can't be empty",
    Action: 'Action',
    'Use Time': 'Use Time',
    Trainer: 'Trainer',
    Location: 'Location',
    Expand: 'Expand',
    Total: 'Total',
    'Client Orders': 'Client Orders',
    'Order ID': 'Order ID',
    User: 'User',
    Price: 'Price',
    'Price With Discount': 'Price With Discount',
    'Sertificate has not found': 'Sertificate has not found',
    "You can't use this service": "You can't use this service",
    'Merge to': 'Merge to',
    Merge: 'Merge',
    'Confirm Merge': 'Confirm Merge',
    MergeClientText:
      'Do you want to merge {{clientName}} to {{selectedClientName}}?',
    'Has club card': 'Has club card',
    'Use сertificate services': 'Use сertificate services',
    SertificateServiceInfo:
      'Has been used: {{usage_count}} out of {{initial_count}}',
    'Services in certificate': 'Services in certificate',
    "Send to client's email": "Send to client's email",
    Print: 'Print',
    Frozen: 'Frozen',
    'Freeze service': 'Freeze service',
    Freeze: 'Freeze',
    'Freeze History': 'Freeze History',
    'Change Expiration': 'Change Expiration',
    'Revert to booking': 'Revert to booking',
    Unfreeze: 'Unfreeze',
    'History of Freezing': 'History of Freezing',
    'View and manage freeze periods for this service.':
      'View and manage freeze periods for this service.',
    'Change Expiration Date': 'Change Expiration Date',
    'Order Type': 'Type',
    'Client Online Orders': 'Client Online Orders',
    'Subscription ID': 'Subscription ID',
    'Order type': 'Order type',
    'Action Type': 'Action Type',
    'Are you sure you want to unfreeze this period?':
      'Are you sure you want to unfreeze this period?',
    'Set the start and end dates for freezing this service.':
      'Set the start and end dates for freezing this service.',
    'Set the new expiration date for this purchased service.':
      'Set the new expiration date for this purchased service.',
    'Order Receipt': 'Order Receipt',
    'Loading receipt...': 'Loading receipt...',
    Close: 'Close',
    'Receipt sent successfully': 'Receipt sent successfully',
    'Show receipt': 'Show receipt',
    'Cancel service usage': 'Cancel service usage',
    'Cancel online order': 'Cancel online order',
    'Cancel order': 'Cancel order',
    'Cancel order to deposit': 'Cancel order to deposit',
    'Additional Fields': 'Additional Fields',
    'Answer missing': 'Answer missing',
    'Access Pass': 'Access Pass',
    'Print Access Pass': 'Print Access Pass',
    Date: 'Date',
    Info: 'Info',
    History: 'History',
    'Client services': 'Services',
    'Purchased at': 'Purchased at',
    'Valid until': 'Valid until',
    'No expiry': 'No expiry',
    Use: 'Use',
    'Service used': 'Service used',
    'Select a location in the header first':
      'Select a location in the header first',
    'Pick the specialist who will deliver this service.':
      'Pick the specialist who will deliver this service.',
    Specialist: 'Specialist',
    'Refund amount': 'Full refund amount',
    'Refund method': 'Refund method',
    'Pay out from cash register': 'Pay out from cash register',
    'Credit to deposit': 'Credit to deposit',
    'Refund reason': 'Refund reason',
    Refund: 'Refund',
    Calculate: 'Calculate',
    'Maximum refund': 'Maximum refund',
    'Suggested refund': 'Suggested refund',
    'No suggestion — enter the amount manually':
      'No suggestion — enter the amount manually',
    'Amount to refund': 'Amount to refund',
    'Amount exceeds the purchase price': 'Amount exceeds the purchase price',
    'The difference is recognised as revenue':
      'The difference is recognised as revenue',
    'Previously recognised revenue is reversed':
      'Previously recognised revenue is reversed',
    'Client services history': 'Client services history',
    'Client Services Tab Hint':
      'Full service history for the client. For quick use, see the client main view.',
    status_purchased: 'Purchased',
    status_pending_booking: 'Held for a booking',
    status_used: 'Used',
    status_expired: 'Expired',
    status_refunded: 'Refunded',
    Status: 'Status',
    'Used at': 'Used at',
    'Used location': 'Used location',
    'Purchased from': 'Purchased from',
    'Purchased till': 'Purchased till',
    General: 'General',
    'New History': 'New History',
    'Sale to client': 'Sale to client',
    Sell: 'Sell',
    'Mixed payment': 'Mixed payment',
    'Client deposit': 'Client deposit',
    'Amount to pay': 'Amount to pay',
    'Distributed funds': 'Distributed funds',
    'Select a cash register': 'Select a cash register',
    'Payments must match the cart total': 'Payments must match the cart total',
    Cards: 'Cards',
    Goods: 'Goods',
    'Usage history': 'Usage history',
    'No usages yet': 'No usages yet',
    'Left to distribute': 'Left to distribute',
    Payment: 'Payment',
    Soon: 'Soon',
    'No services to use': 'No services to use',
    'No cards to use': 'No cards to use',
    status_not_activated: 'Not activated',
    status_active: 'Active',
    expiresOn: 'until',
    Activate: 'Activate',
    'Card discount': 'Card discount',
    'Applying 0% restores the card discount.':
      'Applying 0% restores the card discount.',
    'History and actions': 'History and actions',
    'Deposit: history and actions': 'Deposit: history and actions',
    'Refund from deposit': 'Refund from deposit',
    'Refund funds': 'Refund funds',
    'From cash register': 'From cash register',
    Debt: 'Debt',
    Operation: 'Operation',
    Reason: 'Reason',
    Author: 'Author',
    'Balance after': 'Balance after',
    'Amount exceeds the deposit balance': 'Amount exceeds the deposit balance',
    'Deposit refund amount hint':
      'You can hand back no more than the current deposit balance.',
    'Deposit refund reason hint':
      'The reason is stored with the ledger entry and shows up in reports.',
    'Deposit balance': 'Deposit balance',
    'Deposit debt': 'Deposit debt',
    'On credit': 'On credit',
    'Debt after the sale': 'Debt after the sale',
    'The sale exceeds the client debt limit':
      'The sale exceeds the client debt limit',
    'Make a selection and specify a payment method to create the order.':
      'Make a selection and specify a payment method to create the order.',
    'Available products and services': 'Available products and services',
    'Search products and services...': 'Search products and services...',
    'Buy certificate': 'Buy certificate',
    'Available products and services for certificate':
      'Available products and services for certificate',
    Certificate: 'Certificate',
    'Certificate composition': 'Certificate composition',
    'Pick services or cards on the left, or enter a deposit amount':
      'Pick services or cards on the left, or enter a deposit amount',
    'Deposit amount': 'Deposit amount',
    'Add certificate to cart': 'Add certificate to cart',
    'Save certificate': 'Save certificate',
    'Edit certificate': 'Edit certificate',
    'Redeem certificate': 'Redeem certificate',
    'From certificate': 'From certificate',
    'Services History': 'Services History',
    Orders: 'Orders',
    'Client cards history': 'Client cards history',
    'Client Cards Tab Hint': 'Every card the client has ever bought.',
    'Client orders history': 'Client orders history',
    'Client Orders Tab Hint': 'Every purchase the client has ever paid for.',
    'Activated at': 'Activated at',
    'Visits left': 'Visits left',
    'Sale location': 'Sale location',
    'Order composition': 'Order composition',
    Channel: 'Channel',
    Cashier: 'Cashier',
    channel_offline: 'At the counter',
    channel_online: 'Online',
    'Refund order': 'Refund order',
    'Refund the way it was paid': 'Refund the way it was paid',
    'Order refund target hint':
      'The way it was paid returns every payment to its own register and places a return receipt when the sale was fiscalized. A cash register pays out from a non-fiscal register; the deposit takes the whole order back onto the balance.',
    'Fiscal receipt': 'Fiscal receipt',
    'Fiscal receipt not available': 'The receipt could not be loaded',
    'Sale receipt': 'Sale receipt',
    'Return receipt': 'Return receipt',
    order_status_complete: 'Paid',
    order_status_partially_refunded: 'Partially refunded',
    order_status_refunded: 'Refunded',
    order_status_cancelled: 'Cancelled',
    payment_method_cash: 'Cash',
    payment_method_terminal: 'Terminal',
    payment_method_transfer: 'Transfer',
    payment_method_online: 'Online',
    payment_method_deposit: 'Deposit',
    Certificates: 'Certificates',
    'The client receives what you hand out':
      'The client receives what you hand out',
    'Certificate code': 'Certificate code',
    Find: 'Find',
    'This certificate cannot be redeemed':
      'This certificate cannot be redeemed',
    'What to hand out': 'What to hand out',
    'Nothing left to hand out': 'Nothing left to hand out',
    'Pick at least one line': 'Pick at least one line',
    'More than the certificate has left': 'More than the certificate has left',
    Redeem: 'Redeem',
    'Certificate redeemed': 'Certificate redeemed',
    certificate_redeem_hint:
      'Hand out part of the certificate — the rest stays for later and for other people. The location is taken from the header.',
    'Remove from cart': 'Remove from cart',
    'Remove from certificate': 'Remove from certificate',
    Discount: 'Discount',
    'Discount percent': 'Discount percent',
    'Discount reason': 'Discount reason',
    Apply: 'Apply',
    'Discount percent must be between 0 and 100':
      'Discount percent must be between 0 and 100',
    'Select a discount reason': 'Select a discount reason',
    Page: 'Page',
    of: 'of',
    'Client site': 'Client site',
    'Client site version': 'Client site version',
    'Switch this client to V2 of the client site?':
      'Switch this client to V2 of the client site?',
    'Switch this client to V1 of the client site?':
      'Switch this client to V1 of the client site?',
    Switch: 'Switch',
  },
  uk: {
    ...Clients.uk,
    ...CLIENT_CERTIFICATES_TABLE.uk,
    'Added to black list': 'Додано до чорного списку',
    'Personal Info': 'Особиста інформація',
    'Lead climbing': 'Нижня Страховка',
    'Card Number': 'Номер Картки',
    'Card Numbers': 'Номери Карток',
    'Add Card Number': 'Добавити Номер Картки',
    Comments: 'Коментарі',
    'Buy New Service': 'Купити Новий Сервіс',
    Sale: 'Продати',
    'Buy Service': 'Купити Сервіс',
    ServicesCount: '{{count}} Сервісів',
    'Use Certificate': 'Використати Сертифікат',
    'Certificate Code': 'Код Сертифікату',
    'Certificate Already Used': 'Сертифікат Вже Використаний',
    Cart: 'Кошик',
    'Current Purchased Services': 'Поточні куплені сервіси',
    'Current Active Purchased Services': 'Поточні активні куплені сервіси',
    'Previously Purchased Services Without Discounts':
      'Попередні куплені сервіси(без знижок)',
    'Current Active Discounts': 'Поточні активні знижки',
    'Previously Purchased Discounts': 'Попередні знижки',
    'Discount Type': 'Тип Знижки',
    'Purchased Service Id': 'Id сервісу',
    Service: 'Сервіс',
    'Service Type': 'Тип сервісу',
    'Buy Time': 'Час оплати',
    Expiration: 'Закінчення',
    Balance: 'Баланс',
    'Previously Purchased Services': 'Попередні куплені сервіси',
    'Service Usage History': 'Історія використання сервісів',
    'Payment Types': 'Типи Платежу',
    Card: 'Картка',
    Subscription: 'Підписка',
    UseServiceConfirmText:
      'Ви впевнені, що хочете використати <b>{{name}}</b> \
      сервіс для <b>{{client_name}}</b> ?',
    UseServiceWithTrainerConfirmText:
      'Ви впевнені, що хочете використати \
      <b>{{name}}</b> сервіс для <b>{{client_name}}</b> з тренером \
      <b>{{trainer_name}}</b> ?',
    CancelOrderConfirmText:
      'Ви впевнені, що хочете відмінити замовлення <b>{{order_id}}</b> \
      для <b>{{client_name}}</b>?',
    CancelOnlineOrderConfirmText:
      'Ви впевнені, що хочете відмінити онлайн замовлення <b>{{order_id}}</b> \
      для <b>{{client_name}}</b>?',
    CancelOrderToDepositConfirmText:
      'Ви впевнені, що хочете відмінити замовлення <b>{{order_id}}</b> \
      для <b>{{client_name}}</b> та повернути кошти на депозит?',
    CancelServiceUsageConfirmText:
      'Ви впевнені, що хочете відмінити \
      використання сервісу <b>{{name}}</b> для <b>{{client_name}}</b>?',
    UseServiceText: 'Використати {{service_id}}',
    UseServiceWithTrainerText: 'Використати {{service_id}} з тренером',
    'Add trainers to system to use this service':
      'Добавте тренера в систему, щоб використати сервіс',
    'Client Signature': 'Підпис Клієнта',
    'Client photo': 'Фото клієнта',
    "Cart can't be empty": 'Кошик не може бути пустий',
    Action: 'Дія',
    'Use Time': 'Використовувався',
    Trainer: 'Тренер',
    Location: 'Локація',
    Expand: 'Продовжити',
    Total: 'Разом',
    'Client Orders': 'Замовлення клієнта',
    'Order ID': 'ID Замовлення',
    User: 'Користувач',
    Price: 'Ціна',
    'Price With Discount': 'Ціна з Знижкою',
    'Sertificate has not found': 'Сертифікат не знайдено',
    "You can't use this service": 'Ви не можете використати цей сервіс',
    'Merge to': "Об'єднати з",
    Merge: "Об'єднати",
    'Confirm Merge': "Підтвердити об'єднання",
    MergeClientText:
      "Ви хочете об'єднати {{clientName}} з {{selectedClientName}}? Всі дані будуть в клієнта {{selectedClientName}}",
    'Has club card': 'Є клубна картка',
    'Use сertificate services': 'Використати сервіси Сертифікату',
    SertificateServiceInfo:
      'Було використано: {{usage_count}} із {{initial_count}}',
    'Services in certificate': 'Сервіси в сертифікаті',
    "Send to client's email": 'Надіслати на імейл клієнта',
    Print: 'Роздрукувати',
    Frozen: 'Заморожений',
    'Freeze service': 'Заморозити сервіс',
    Freeze: 'Заморозити',
    'Freeze History': 'Історія заморозки',
    'Change Expiration': 'Змінити термін дії',
    'Revert to booking': 'Повернути до бронювання',
    Unfreeze: 'Розморозити',
    'History of Freezing': 'Історія заморожень',
    'View and manage freeze periods for this service.':
      'Переглянути та керувати періодами замороження для цього сервісу.',
    'Change Expiration Date': 'Змінити дату закінчення',
    'Order Type': 'Тип',
    'Client Online Orders': 'Замовлення клієнта онлайн',
    'Subscription ID': 'ID Підписки',
    'Order type': 'Тип замовлення',
    'Action Type': 'Тип дії',
    'Are you sure you want to unfreeze this period?':
      'Ви впевнені, що хочете розморозити цей період?',
    'Set the start and end dates for freezing this service.':
      'Встановіть початкову та кінцеву дати для замороження цього сервісу.',
    'Set the new expiration date for this purchased service.':
      'Встановіть нову дату закінчення для цього купленого сервісу.',
    'Order Receipt': 'Чек замовлення',
    'Loading receipt...': 'Завантаження чеку...',
    Close: 'Закрити',
    'Receipt sent successfully': 'Чек успішно надіслано',
    'Show receipt': 'Показати чек',
    'Cancel service usage': 'Скасувати використання сервісу',
    'Cancel online order': 'Скасувати онлайн замовлення',
    'Cancel order': 'Скасувати замовлення',
    'Cancel order to deposit': 'Скасувати замовлення на депозит',
    'Additional Fields': 'Додаткові поля',
    'Answer missing': 'Відповідь відсутня',
    'Access Pass': 'Перепустка',
    'Print Access Pass': 'Друк перепустки',
    Date: 'Дата',
    Info: 'Інформація',
    History: 'Історія',
    'Client services': 'Послуги',
    'Purchased at': 'Куплено',
    'Valid until': 'Діє до',
    'No expiry': 'Безстроково',
    Use: 'Використати',
    'Service used': 'Послугу використано',
    'Select a location in the header first': 'Спершу оберіть локацію у шапці',
    'Pick the specialist who will deliver this service.':
      'Виберіть фахівця, який надасть цю послугу.',
    Specialist: 'Фахівець',
    'Refund amount': 'Повна сума повернення',
    'Refund method': 'Спосіб повернення',
    'Pay out from cash register': 'Видати з каси',
    'Credit to deposit': 'Зарахувати на депозит',
    'Refund reason': 'Причина повернення',
    Refund: 'Повернути',
    Calculate: 'Розрахувати',
    'Maximum refund': 'Максимальна сума повернення',
    'Suggested refund': 'Рекомендована сума',
    'No suggestion — enter the amount manually':
      'Немає рекомендації — введіть суму вручну',
    'Amount to refund': 'Сума до повернення',
    'Amount exceeds the purchase price': 'Сума перевищує вартість покупки',
    'The difference is recognised as revenue': 'Різниця визнається як виручка',
    'Previously recognised revenue is reversed':
      'Раніше визнана виручка сторнується',
    'Client services history': 'Історія послуг клієнта',
    'Client Services Tab Hint':
      'Повна історія послуг клієнта. Для швидкого використання — основний вью клієнта.',
    status_purchased: 'Куплена',
    status_pending_booking: 'Утримана під запис',
    status_used: 'Використана',
    status_expired: 'Прострочена',
    status_refunded: 'Повернена',
    Status: 'Статус',
    'Used at': 'Використано',
    'Used location': 'Локація використання',
    'Purchased from': 'Куплено від',
    'Purchased till': 'Куплено до',
    General: 'Загальне',
    'New History': 'Нова історія',
    'Sale to client': 'Продаж клієнту',
    Sell: 'Продати',
    'Mixed payment': 'Змішаний платіж',
    'Client deposit': 'Депозит клієнта',
    'Amount to pay': 'До сплати',
    'Distributed funds': 'Розподілені кошти',
    'Select a cash register': 'Оберіть касу',
    'Payments must match the cart total':
      'Сума оплат має дорівнювати сумі замовлення',
    Cards: 'Картки',
    Goods: 'Товари',
    'Usage history': 'Історія використання',
    'No usages yet': 'Використань поки немає',
    'Left to distribute': 'Залишилось розподілити',
    Payment: 'Оплата',
    Soon: 'Скоро',
    'No services to use': 'Немає послуг для використання',
    'No cards to use': 'Немає карток для використання',
    status_not_activated: 'Не активована',
    status_active: 'Активна',
    expiresOn: 'до',
    Activate: 'Активувати',
    'Card discount': 'Карткова знижка',
    'Applying 0% restores the card discount.':
      'Застосування 0% поверне карткову знижку.',
    'History and actions': 'Історія та дії',
    'Deposit: history and actions': 'Депозит: історія та дії',
    'Refund from deposit': 'Повернення коштів з депозиту',
    'Refund funds': 'Повернути кошти',
    'From cash register': 'З каси',
    Debt: 'Борг',
    Operation: 'Операція',
    Reason: 'Причина',
    Author: 'Автор',
    'Balance after': 'Баланс після',
    'Amount exceeds the deposit balance': 'Сума перевищує баланс депозиту',
    'Deposit refund amount hint':
      'Повернути можна не більше поточного балансу депозиту.',
    'Deposit refund reason hint':
      'Причина зберігається разом із проводкою і потрапляє у звіти.',
    'Deposit balance': 'Баланс депозиту',
    'Deposit debt': 'Борг за депозитом',
    'On credit': 'У кредит',
    'Debt after the sale': 'Борг після продажу',
    'The sale exceeds the client debt limit':
      'Продаж перевищує ліміт боргу клієнта',
    'Make a selection and specify a payment method to create the order.':
      'Зробіть вибір та вкажіть спосіб оплати для створення замовлення.',
    'Available products and services': 'Доступні товари і послуги',
    'Search products and services...': 'Пошук товарів і послуг...',
    'Buy certificate': 'Купити сертифікат',
    'Available products and services for certificate':
      'Доступні товари і послуги для сертифіката',
    Certificate: 'Сертифікат',
    'Certificate composition': 'Наповнення сертифіката',
    'Pick services or cards on the left, or enter a deposit amount':
      'Оберіть послуги чи картки ліворуч або вкажіть суму депозиту',
    'Deposit amount': 'Сума депозиту',
    'Add certificate to cart': 'Додати сертифікат у кошик',
    'Save certificate': 'Зберегти сертифікат',
    'Edit certificate': 'Редагувати сертифікат',
    'Redeem certificate': 'Використати сертифікат',
    'From certificate': 'Із сертифіката',
    'Services History': 'Історія послуг',
    Orders: 'Замовлення',
    'Client cards history': 'Історія карток клієнта',
    'Client Cards Tab Hint': 'Усі картки, які колись придбав клієнт.',
    'Client orders history': 'Історія замовлень клієнта',
    'Client Orders Tab Hint': 'Усі покупки, які колись оплатив клієнт.',
    'Activated at': 'Активована',
    'Visits left': 'Залишок візитів',
    'Sale location': 'Локація продажу',
    'Order composition': 'Склад замовлення',
    Channel: 'Канал',
    Cashier: 'Касир',
    channel_offline: 'На касі',
    channel_online: 'Онлайн',
    'Refund order': 'Повернення замовлення',
    'Refund the way it was paid': 'Повернути так, як платили',
    'Order refund target hint':
      '«Як платили» повертає кожну оплату у свою касу і створює чек повернення, якщо продаж було фіскалізовано. Каса — видача з нефіскальної каси; депозит — усе замовлення повертається на баланс клієнта.',
    'Fiscal receipt': 'Фіскальний чек',
    'Fiscal receipt not available': 'Не вдалося завантажити чек',
    'Sale receipt': 'Чек продажу',
    'Return receipt': 'Чек повернення',
    order_status_complete: 'Оплачене',
    order_status_partially_refunded: 'Частково повернене',
    order_status_refunded: 'Повернене',
    order_status_cancelled: 'Скасоване',
    payment_method_cash: 'Готівка',
    payment_method_terminal: 'Термінал',
    payment_method_transfer: 'Переказ',
    payment_method_online: 'Онлайн',
    payment_method_deposit: 'Депозит',
    Certificates: 'Сертифікати',
    'The client receives what you hand out': 'Отримувач',
    'Certificate code': 'Код сертифіката',
    Find: 'Знайти',
    'This certificate cannot be redeemed':
      'Цей сертифікат не можна використати',
    'What to hand out': 'Що видати',
    'Nothing left to hand out': 'Видавати більше нічого',
    'Pick at least one line': 'Оберіть хоча б одну позицію',
    'More than the certificate has left':
      'Більше, ніж залишилось на сертифікаті',
    Redeem: 'Використати',
    'Certificate redeemed': 'Сертифікат використано',
    certificate_redeem_hint:
      'Видайте частину сертифіката — решта лишається на потім і для інших людей. Локація береться з шапки.',
    'Remove from cart': 'Видалити з кошика',
    'Remove from certificate': 'Видалити із сертифіката',
    Discount: 'Знижка',
    'Discount percent': 'Відсоток знижки',
    'Discount reason': 'Причина знижки',
    Apply: 'Застосувати',
    'Discount percent must be between 0 and 100':
      'Відсоток знижки має бути від 0 до 100',
    'Select a discount reason': 'Оберіть причину знижки',
    Page: 'Сторінка',
    of: 'з',
    'Client site': 'Клієнтський сайт',
    'Client site version': 'Версія клієнтського сайту',
    'Switch this client to V2 of the client site?':
      'Перемкнути цього клієнта на V2 клієнтського сайту?',
    'Switch this client to V1 of the client site?':
      'Перемкнути цього клієнта на V1 клієнтського сайту?',
    Switch: 'Перемкнути',
  },
};
